export const LANDING = '/'
export const RECIPIENTS = '/recipients'
export const DOCUMENTS = '/documents'